export default "__VITE_ASSET__Dq76ngQQ__"